import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { ProtectedRoute, LoginRoute } from "./components/ProtectedRoute";
import { PromoPopup } from "./components/PromoPopup";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import { QuoteCartProvider } from "./context/QuoteCartContext";
import { WishlistProvider } from "./context/WishlistContext";

// Páginas Públicas
import { Home } from "./pages/Home";
import { Catalogo } from "./pages/Catalogo";
import { Produto } from "./pages/Produto";
import { Marcas } from "./pages/Marcas";
import { Sobre } from "./pages/Sobre";
import { Contato } from "./pages/Contato";
import { Orcamento } from "./pages/Orcamento";
import { Favoritos } from "./pages/Favoritos";

// Páginas Administrativas
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminDashboard } from "./pages/admin/AdminDashboard";

/**
 * Componente de Layout para Páginas Públicas
 * Inclui Header, Footer, Popup e WhatsApp
 */
const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <PromoPopup />
    <WhatsAppButton />
  </>
);

/**
 * Página 404 - Não Encontrado
 */
const NotFound = () => (
  <PublicLayout>
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center">
        <h1 className="text-6xl font-medium text-[#0A0A0A] mb-4">404</h1>
        <p className="text-lg text-[#4B5563] mb-8 font-medium">Página não encontrada</p>
        <a href="/" className="bg-[#EA1266] text-white px-8 py-3 rounded-full font-medium hover:bg-[#d00f58] transition-colors text-sm uppercase tracking-wider">
          Voltar para Home
        </a>
      </div>
    </div>
  </PublicLayout>
);

function App() {
  return (
    <HelmetProvider>
    <SiteSettingsProvider>
    <QuoteCartProvider>
    <WishlistProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* ==================== ROTAS PÚBLICAS ==================== */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/catalogo" element={<PublicLayout><Catalogo /></PublicLayout>} />
          <Route path="/produto/:slug" element={<PublicLayout><Produto /></PublicLayout>} />
          <Route path="/marcas" element={<PublicLayout><Marcas /></PublicLayout>} />
          <Route path="/sobre" element={<PublicLayout><Sobre /></PublicLayout>} />
          <Route path="/contato" element={<PublicLayout><Contato /></PublicLayout>} />
          <Route path="/orcamento" element={<PublicLayout><Orcamento /></PublicLayout>} />
          <Route path="/favoritos" element={<PublicLayout><Favoritos /></PublicLayout>} />
          
          {/* ==================== ROTAS ADMINISTRATIVAS ==================== */}
          
          {/* Redirecionamento: /admin-painel-gestao -> /admin-painel-gestao/login */}
          <Route 
            path="/admin-painel-gestao" 
            element={<Navigate to="/admin-painel-gestao/login" replace />} 
          />
          
          {/* Login do Admin (redireciona para dashboard se já autenticado) */}
          <Route 
            path="/admin-painel-gestao/login" 
            element={
              <LoginRoute>
                <AdminLogin />
              </LoginRoute>
            } 
          />
          
          {/* Dashboard do Admin (protegido - requer autenticação) */}
          <Route 
            path="/admin-painel-gestao/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* ==================== PÁGINA 404 ==================== */}
          {/* Captura qualquer rota não definida */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        
        <Toaster />
      </BrowserRouter>
    </div>
    </WishlistProvider>
    </QuoteCartProvider>
    </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
